module.exports = __webpack_public_path__ + "img/sales_ecommerce_checkout.122854f0.svg";